module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("To Kirstie and Ruth thank you both for the listening ear, for being there for me. Lots of banter and a hell of a lot of laughter. Ruth thank you for the wine and having me in tears and stitches with the belly laughs.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("I would like to say thank you to the editors at Austin Macauley for taking a chance on me and for enjoying reading the manuscript. A huge amount of thanks has to go to my publication team for bringing my book to life. You have all been amazing with each step of the way. Lastly to my children for being understanding and patient, when I’ve been working and you’ve been trying to talk to me. I have ignored you on many occasions, due to being switched off and in the zone. I love you and I really appreciate you. Thank you for letting me do what I needed to and what I love.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254a15be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0